import {createSelector} from '@reduxjs/toolkit';
import { get } from 'lodash';

export const aiSummaryExpenseReducer = {
 
  getHqDropDownForAISummaryExpense: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.hqDropDownForAISummaryExpense],
      hqDropDownForAISummaryExpense => hqDropDownForAISummaryExpense,
    );
  },

  getCategoryDropDownForAISummaryExpense: () => {
    return createSelector(
      [
        (state: any) =>
          state.aiSummaryExpense.categoryDropDownForAISummaryExpense,
      ],
      categoryDropDownForAISummaryExpense =>
        categoryDropDownForAISummaryExpense,
    );
  },

  getAISummaryExpenseGridData: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.aiSummaryExpenseData],
      aiSummaryExpenseData => aiSummaryExpenseData,
    );
  },

  getAISummarySummaryData: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.aiSummarySummaryData],
      aiSummarySummaryData => aiSummarySummaryData,
    );
  },

  getAISummaryCategoriesData: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.aiSummaryCategoriesData],
      aiSummaryCategoriesData => aiSummaryCategoriesData,
    );
  },

  getAISummaryExpenseCompleteData: () => {  
    return createSelector(
      [(state: any) => state.aiSummaryExpense.aiSummaryExpenseCompleteData],
      aiSummaryExpenseCompleteData => aiSummaryExpenseCompleteData,
    );
  },

    getAISummaryExpenseGridPaginationData: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.aiSummaryPaginationData],
      aiSummaryPaginationData => aiSummaryPaginationData,
    );
  },

  getShowLoader: () => {
    return createSelector(
      [(state: any) => state.aiSummaryExpense.showLoader],
      showLoader => showLoader,
    );
  },
  
};
